import React from "react";
import AddMarkSection from "../components/units/section/write/AddMarkSection";
import DeleteMarkSection from "../components/units/section/write/DeleteMarkSection";
import GeneratedContent from "../components/units/section/write/GeneratedContent";
import SEO from "../components/seo/SEO";
import { seoConfig } from "../config/seoConfig";

const Write_component = () => {
  return (
    <>
      <SEO {...seoConfig.home} path="/write" />
      <main className="write pt-0">
        {/* 添加附图标记功能块 */}
        <AddMarkSection />
        {/* 删除附图标记功能块 */}
        <DeleteMarkSection />
        {/* 生成发明内容功能块 */}
        <GeneratedContent />
      </main>
    </>
  );
};
export default Write_component;
